import { useQuery, useQueryClient } from "@tanstack/react-query"
import { auth, profile } from  '@shared/api/services'
import { getTimezone } from '@utils/lib/getTimezone';

export const useProfile = () => {
	const queryClient = useQueryClient()

	const response = useQuery({
		queryKey: ['profile'], 
		queryFn: () => auth.me().then(response => {
				if(response?.data && !response.data?.timezone){
					profile.updateProfile({timezone: getTimezone()}).then(res => {
						queryClient.invalidateQueries(['profile']) 

						return res
					})
				}
				
				return response
			})
			, 
		enabled: !!localStorage.getItem("token"),
		select: (data) => data.data,
		retry: 3
	})



	return response
}